/**
 * WOODWORKING FURNITURE PLANS™ — purchase configuration.
 *
 * CHECKOUT_URL is the single destination used by every purchase button
 * (offer CTA, final CTA and mobile sticky bar). Paste the Woodworking
 * checkout URL here when it is available (must start with https://).
 *
 * While it is empty, every purchase button scrolls to the offer (#offer)
 * so no visitor is sent to a wrong or missing checkout.
 */
export const CHECKOUT_URL = 'https://woodworking-furniture-plans.impultienda.ar/checkout'

export const PRICE = {
  value: 35,
  currency: 'USD',
  label: 'US$35',
  compareAtLabel: 'US$74',
  savingsLabel: 'US$39',
  discountLabel: '53%',
  perProjectLead: '60 furniture projects. US$35 total.',
  perProjectHighlight: 'Less than US$0.59 per project.',
  perProjectNote: 'Average per project within the complete collection.',
  delivery: 'Receive all 6 PDF volumes and 5 bonus resources by email immediately after payment.',
  note: 'One-time payment. Digital PDF collection.',
} as const
